<template>
  <div>
    <div class="passport">
      <div class="row">
        <div class="col-md-3 col-sm-3 col-xs-3">
          <span class="name-label">Дата рождения</span>
          <p>
            {{ passport.birthday || '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification && passport.scan_data.identification.number"
              :class="{ 'text-green': birthdayCorrect, 'text-red': !birthdayCorrect }"
            >
              <br>
              {{ passport.scan_data.birthday || '-' }}
            </span>
          </p>
        </div>
        <div class="col-md-6 col-xs-6">
          <span class="name-label">Место рождения</span>
          <p>
            {{ passport.placebirth || '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification && passport.scan_data.identification.number"
              :class="{ 'text-green': placebirthCorrect, 'text-red': !placebirthCorrect }"
            >
              <br>
              {{ passport.scan_data.placebirth || '-' }}
            </span>
          </p>
        </div>
        <div class="col-md-2 col-xs-2">
          <span class="name-label">Гражданство</span>
          <p v-if="passport.nationality && passport.nationality.iso2" class="visitor-nationality">
            <img
              :src="baseUrl + '/img/icons/' + passport.nationality.iso2 + '.svg'"
              alt="icon-flag"
              class='icon-flag'
            >{{ passport.nationality.fullName || '-' }}
            <span
              v-if="passport.scan_data.nationality && passport.scan_data.nationality.iso2"
              :class="{ 'text-green': nationalityCorrect, 'text-red': !nationalityCorrect }"
            >
              <br>
              <img
                :src="baseUrl + '/img/icons/' + passport.scan_data.nationality.iso2 + '.svg'"
                alt="icon-flag"
                class='icon-flag'
              >{{ passport.scan_data.nationality.fullName || '-' }}
            </span>
            <span
              v-else-if="passport.scan_data.nationality"
              :class="{ 'text-green': nationalityCorrect, 'text-red': !nationalityCorrect }"
            >
              <br>-
            </span>
          </p>
          <p v-else>-</p>
        </div>
        <div>
          <button
            :title="titleApplicationsButton"
            role="button"
            class="btn btn-default"
            @click="changeVisibleApplications"
          >
            <i class="fa fa-bars"></i>
            &nbsp;
            <i :class="{ 'fa-angle-down': !visibleApplications, 'fa-angle-up': visibleApplications }" class="fa"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-xs-3 mobile-width-75" style="height: 65px">
          <span class="name-label">Вид документа</span>
          <p>
            {{ identification ? identification.name || '-' : '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification"
              :class="{ 'text-green': identificationNameCorrect, 'text-red': !identificationNameCorrect }"
            >
              <br>
              {{ passport.scan_data.identification.name || '-' }}
            </span>
          </p>
        </div>
        <div class="col-md-3 col-xs-3" style="height: 65px">
          <span class="name-label">Серия и номер</span>
          <span v-if="passportIsDuplicate()" class="visitor-passport-is-duplicate">
          <label style="margin-bottom: auto">!</label>
            <div class="form-fieldhelp-text">
              <div style="font-size: 14px; font-weight: normal">
                 Паспорт с&nbsp;таким же номером встречается у&nbsp;других посетителей
              </div>
            </div>
        </span>
        <a v-if="passportIsDuplicate()" :href="`?search=${identification.number}`">
          <p>
            {{ identification ? identification.number || '-' : '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification"
              :class="{ 'text-green': identificationNumberCorrect, 'text-red': !identificationNumberCorrect }"
            >
              <br>
              {{ passport.scan_data.identification.number || '-' }}
            </span>
          </p>
        </a>
          <p v-else >
            {{ identification ? identification.number || '-' : '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification"
              :class="{ 'text-green': identificationNumberCorrect, 'text-red': !identificationNumberCorrect }"
            >
              <br>
              {{ passport.scan_data.identification.number || '-' }}
            </span>
          </p>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-3 mobile-width-75">
          <span class="name-label">Дата выдачи</span>
          <p>
            {{ identification ? identification.date_of || '-' : '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification"
              :class="{ 'text-green': identificationDateOfCorrect, 'text-red': !identificationDateOfCorrect }"
            >
              <br>
              {{ passport.scan_data.identification.date_of || '-' }}
            </span>
          </p>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-3">
          <span class="name-label">Дата окончания</span>
          <p>
            {{ identification ? identification.date_to || '-' : '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification"
              :class="{ 'text-green': identificationDateToCorrect, 'text-red': !identificationDateToCorrect }"
            >
              <br>
              {{ passport.scan_data.identification.date_to || '-' }}
            </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9 col-xs-9">
          <span class="name-label">Кем выдан</span>
          <p>
            {{ identification ? identification.place || '-' : '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification"
              :class="{ 'text-green': identificationPlaceCorrect, 'text-red': !identificationPlaceCorrect }"
            >
              <br>
              {{ passport.scan_data.identification.place || '-' }}
            </span>
          </p>
        </div>
        <div class="col-md-3 col-xs-3">
          <span class="name-label">Код подразделения</span>
          <p>
            {{ identification ? identification.code || '-' : '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification"
              :class="{ 'text-green': identificationCodeCorrect, 'text-red': !identificationCodeCorrect }"
            >
              <br>
              {{ passport.scan_data.identification.code || '-' }}
            </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <span class="name-label">Адрес</span>
          <p>
            {{ passport.address || '-' }}
            <span
              v-if="passport.scan_data && passport.scan_data.identification && passport.scan_data.identification.number"
              :class="{ 'text-green': identificationAddressCorrect, 'text-red': !identificationAddressCorrect }"
            >
              <br>
              {{ passport.scan_data.address || '-' }}
            </span>
          </p>
        </div>
      </div>
      <visitor-documents-block :documents="documents" />
    </div>

    <passport-application-list
      v-if="visibleApplications"
      :visitor-key="visitorKey"
      :passport-id="passport.id"
      :required-archived="requiredArchived"
      :statuses="statuses"
      @open-application="openApplication"
      @update-statuses="updateStatuses"
      @splice-application="spliceApplication"
    />
  </div>
</template>

<script>
import VisitorDocumentsBlock from './VisitorDocumentsBlock.vue'
import PassportApplicationList from '@/common/components/visitor/PassportApplicationList.vue'

export default {
  name: 'VisitorPassportItem',

  components: {
    PassportApplicationList,
    VisitorDocumentsBlock
  },

  props: {
    passport: {
      id: Number,
      address: String,
      birthday: String,
      documents: [Object, Array],
      identification: {
        name: String,
        number: String,
        date_of: String,
        date_to: String,
        place: String,
        code: String
      },
      nationality: {
        iso2: String,
        fullName: String
      },
      placebirth: String,
      scan_data: {
        address: String,
        birthday: String,
        documents: [Object, Array],
        identification: {
          name: String,
          number: String,
          date_of: String,
          date_to: String,
          place: String,
          code: String
        },
        nationality: {
          iso2: String,
          fullName: String
        },
        placebirth: String
      }
    },
    openApplicationsList: {
      type: Boolean,
      default: false
    },
    passportKey: Number,
    requiredArchived: {
      type: Boolean,
      default: false
    },
    visitorKey: Number,
    statuses: { type: Object },
    duplicates: null
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      titleApplicationsButton: 'Показать список заявок',
      showApplications: false
    }
  },

  computed: {
    identification() {
      return this.passport.identification
    },

    documents() {
      return this.passport.documents
    },

    birthdayCorrect() {
      return this.passport.birthday === this.passport.scan_data.birthday
    },

    placebirthCorrect() {
      if (!this.passport.placebirth || !this.passport.scan_data.placebirth) {
        return false
      }

      const passportPlacebirth = this.passport.placebirth
        .toLowerCase()
        .replace(/г\.+/g, '')
        .replace(/гор\.+/g, '')
        .replace(/районе+/g, '')
        .replace(/р-не+/g, '')
        .replace(/[\s.,]/g, '')

      const scanDataPlaceBirth = this.passport.scan_data.placebirth
        .toLowerCase()
        .replace(/г\.+/g, '')
        .replace(/гор\.+/g, '')
        .replace(/районе+/g, '')
        .replace(/р-не+/g, '')
        .replace(/[\s.,]/g, '')

      return passportPlacebirth === scanDataPlaceBirth
    },

    nationalityCorrect() {
      return this.passport?.nationality?.fullName === this.passport.scan_data?.nationality?.fullName
    },

    identificationNameCorrect() {
      return this.passport?.identification?.name === this.passport.scan_data?.identification?.name
    },

    identificationNumberCorrect() {
      if (!this.passport?.identification?.number || !this.passport.scan_data?.identification?.number) {
        return false
      }

      return this.passport?.identification?.number.replace(/\s+/g, '') ===
        this.passport.scan_data?.identification?.number.replace(/\s+/g, '')
    },

    identificationDateOfCorrect() {
      return this.passport?.identification?.date_of === this.passport.scan_data?.identification?.date_of
    },

    identificationDateToCorrect() {
      return this.passport?.identification?.date_to === this.passport.scan_data?.identification?.date_to
    },

    identificationPlaceCorrect() {
      if (!this.passport?.identification?.place || !this.passport.scan_data?.identification?.place) {
        return false
      }

      const passportIdentificationPlace = this.passport?.identification?.place
        .toLowerCase()
        .replace(/г\.+/g, '')
        .replace(/гор\.+/g, '')
        .replace(/районе+/g, '')
        .replace(/р-не+/g, '')
        .replace(/[\s.,]/g, '')

      const scanDataIdentificationPlace = this.passport.scan_data?.identification?.place
        .toLowerCase()
        .replace(/г\.+/g, '')
        .replace(/гор\.+/g, '')
        .replace(/р-не+/g, '')
        .replace(/[\s.,]/g, '')

      return passportIdentificationPlace === scanDataIdentificationPlace
    },

    identificationCodeCorrect() {
      return this.passport?.identification?.code === this.passport.scan_data?.identification?.code
    },

    identificationAddressCorrect() {
      return this.passport?.address === this.passport.scan_data?.address
    },

    visibleApplications() {
      return this.showApplications
    }
  },

  methods: {
    async changeVisibleApplications() {
      this.titleApplicationsButton = 'Показать список заявок'
      if (!this.showApplications) {
        this.titleApplicationsButton = 'Скрыть список заявок'
      }
      this.showApplications = !this.showApplications
    },

    openApplication(applicationKey) {
      this.$emit('open-application', applicationKey)
    },

    spliceApplication(deleteFrom, blockId, applicationId, index) {
      this.$emit('splice-application', deleteFrom, blockId, applicationId, index)
    },

    updateStatuses(status) {
      this.$emit('update-statuses', status)
    },

    passportIsDuplicate() {
      return this.duplicates ? this.duplicates[this.identification.number] : null
    }
  },

  mounted() {
    if (this.openApplicationsList && !this.showApplications) {
      this.changeVisibleApplications()
    }
  }
}
</script>
